/**
 * @generated SignedSource<<e58e83f8c38e39de49c39198288995e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVDashboardPickerButton_dashboard$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TVDashboardPickerButton_dashboard";
};
export type TVDashboardPickerButton_dashboard$key = {
  readonly " $data"?: TVDashboardPickerButton_dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerButton_dashboard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVDashboardPickerButton_dashboard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "3aa3fcd940d4b0c5136fa0db2dc7d45f";

export default node;
